<template>
  <div class="loan-list">
    <!--导航-->
    <div class="dk-nav">
      <van-nav-bar
              fixed
              :title="detail.name"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>

    <!--贷款详情-->
    <div>
      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>一、请长按下方二维码识别进入</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title" style="text-align: center;">
             <van-image
               width="260"
               height="260"
               :src="detail.rwm"
             />
             <p>{{detail.name}}</p>
          </div>
        </div>
      </div>

      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>二、操作系统说明书</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title">
            <p>1、请长按二维码 识别进入查谱。</p>
            <p>2、需要更改信息时，请在“其它纠正”框内输入需求。</p>
            <p>3、请备注联系人的电话，方便审核校对时联络您，电话不会对外公布。</p>
            <p>4、添丁格式：<u>添男/女，名字，出生日期，出生地，联系人电话。</u></p>
            <p>5、婚配格式：<u>娶/嫁，名字，日期，对方地名，联系人电话。</u></p>
            <p>6、仙逝格式：<u>仙逝，日期，葬地，联系人电话。</u></p>
            <p>7、因为需要人工审核，每年一次更新。</p>
            <p>8、考虑信息安全，建议出生日期只写年，地名只到县/乡/村。</p>
          </div>
        </div>
      </div>

      <div class="van-cell-group van-hairline--top-bottom">
        <div class="van-cell" style="background-color: #ebedf0;">
          <div class="van-cell__title">
            <span>三、长按下方二维码 找陈小龙</span>
          </div>
        </div>
        <div class="van-cell">
          <div class="van-cell__title" style="text-align: center;">
             <van-image
               width="100%"
               height="150"
               :src="require('../../../public/static/cxllx.jpg')"
             />
          </div>
        </div>
      </div>

    </div>

    </div>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
export default {
    'name': 'LoanList',
    data() {
        return {

        };
    },
    computed: {
      ...mapState({
          detail: state => state.root.manual_two_detail
      })
    },
    methods: {
      ...mapActions(['requestManualTwoShow']),
      onClickLeft() {
          this.$router.push({path: '/ychomelist?id='+this.detail.category_id+'&name='+this.detail.name});
      }
    },
    mounted() {
        this.requestManualTwoShow({"thit":this,"id":this.$route.query.id});
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.loan-list >>> .van-nav-bar {
  z-index: 9;
  background-color: #ed3f2c;
  padding-top: 6px;
}
.loan-list >>> .van-nav-bar__text {
  color: #fff;
}
.loan-list >>> .van-nav-bar__title {
  color: #fff;
}
.loan-list >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.loan-list >>> .van-nav-bar .van-icon {
  color: #fff;
}
/* 取消伪类 */
.dk-header-after::after {
  border-bottom:none;
}
.dk-footer-after::after {
  border-top:none;
}
</style>
